import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useContext, useLayoutEffect } from 'react';
import { useFormControl } from '@material-ui/core';
import FormFieldContext from './internal/FormFieldContext';
import FormFieldPopoutContext from './internal/FormFieldPopoutContext';

function useFormFieldProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      focusVisible = _ref.focusVisible;

  var formControlProps = useFormControl();

  var _ref2 = useContext(FormFieldContext) || {},
      setFocusVisible = _ref2.setFocusVisible,
      formFieldProps = _objectWithoutProperties(_ref2, ["setFocusVisible"]);

  var popoutProps = useContext(FormFieldPopoutContext) || {};
  useLayoutEffect(function () {
    if (focusVisible !== undefined && setFocusVisible) {
      setFocusVisible(focusVisible);
    }
  }, [focusVisible, setFocusVisible]);
  return _assign({
    inFormField: formControlProps !== undefined,
    setFocusVisible: setFocusVisible
  }, formControlProps, formFieldProps, popoutProps);
}

export default useFormFieldProps;